export default __webpack_public_path__ + "static/media/happy-young-couple-enjoying-their-brand-new-car.a5c2ebb6.png";